import store from '@/store'

import { lazyLoad } from './index'

export default {
  path: '/customer',
  component: lazyLoad('Customer/layout'),
  redirect: 'customer/orders',
  meta: { requiresAuth: true },
  beforeEnter: (to, from, next) => {
    if (store.getters.isCustomer) { next() } else { next('/') }
  },
  children: [
    { path: 'orders',
      component: lazyLoad('Customer/Orders/Layout'),
      children: [
        {
          path: 'cart',
          component: lazyLoad('Customer/Orders/CustomerCart')
        },
        {
          path: 'orders',
          component: lazyLoad('Customer/Orders/CustomerOrders')
        },
        {
          path: 'products',
          component: lazyLoad('Customer/Orders/CustomerProducts')
        }
      ]
    },
    { path: 'marketing',
      component: lazyLoad('Customer/Marketing/Layout'),
      children: [
        {
          path: 'overview',
          component: lazyLoad('Customer/Marketing/Overview')
        },
        {
          path: 'images',
          component: lazyLoad('Customer/Marketing/Images')
        }
      ]
    }
  ]
}
